import { render, staticRenderFns } from "./fccAbaConfiguracao.vue?vue&type=template&id=315eed50"
import script from "./fccAbaConfiguracao.vue?vue&type=script&lang=js"
export * from "./fccAbaConfiguracao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports